<template>
<w-settings-content-template>
  <el-tabs slot="content" type="card" v-model="activeTab" @tab-click="onChangeMenu">
    <el-tab-pane label="알람 전송 정보" name="AlarmForSetting" class="h100 w100">
      <w-alarm-for-setting ref="alarmForSetting"></w-alarm-for-setting>
    </el-tab-pane>
    <el-tab-pane label="알람 전송 템플릿" name="AlarmTemplate" class="h100 w100">
      <w-alarm-template ref="alarmTemplate"></w-alarm-template>
    </el-tab-pane>
    <el-tab-pane label="알람 전송 결과" name="AlarmResult" class="h100 w100">
      <w-alarm-result ref="alarmResult"></w-alarm-result>
    </el-tab-pane>
  </el-tabs>
</w-settings-content-template>
</template>

<script>
import WSettingsContentTemplate from '@/components/template/SettingsContentTemplate';
import WAlarmForSetting from './AlarmForSetting';
import WAlarmTemplate from './AlarmTemplate';
import WAlarmResult from './AlarmResult';

export default {
  name: 'WAlarmSettings',
  components: {
    WSettingsContentTemplate,
    WAlarmForSetting,
    WAlarmTemplate,
    WAlarmResult,
  },
  data() {
    return {
      activeTab: 'AlarmForSetting',
    };
  },
  methods: {
    onChangeMenu(activeTab) {
      if (activeTab.name === 'AlarmResult') {
        this.$refs.alarmResult.loadData();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/AlarmSettings/index.vue